import { MuiStylesType } from 'model/muiStyles.model';
import zeplinColor from 'theme/Color';

export const muiStyles: MuiStylesType = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: '8px', xl: '16px' },
    overflowY: 'scroll',
    border: `1px solid ${zeplinColor.Neutral5}`,
    borderRadius: '14px',
    padding: '16px',
  },
  contentGrid: {
    display: 'grid',
    rowGap: '32px',
    columnGap: '80px',
    gridTemplateColumns: 'repeat(3,1fr)',
  },
  gridItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
};
